import { useTranslation } from 'react-i18next';
import { UserTypesEnum } from '~/constants/enums';
import { UserData } from '~/types/userTypes';

const getUserTypeTitle = (user: UserData['user']) => {
  const { t } = useTranslation('app');
  switch (user?.user_type) {
    case UserTypesEnum.BROKER:
      return t('broker');
    case UserTypesEnum.BUYER:
      return t('buyer');
    case UserTypesEnum.INDIVIDUAL:
      return t('privateOwner');
    case UserTypesEnum.COMPOUND_DEVELOPER:
      return t('compoundDeveloper');
    case UserTypesEnum.SMALL_DEVELOPER:
      return t('buildingDeveloper');
    default:
      return UserTypesEnum.ALL_TYPES;
  }
};

export default getUserTypeTitle;
